// extracted by mini-css-extract-plugin
export default {"capacityWrapper":"styles_capacityWrapper__BQsge","capacityDropdownWrapper":"styles_capacityDropdownWrapper__4TE++"};